import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { PlaylistVideo } from '@/store/playlist/types';
import { EpisodeList } from './EpisodeList';
import { formatTime } from '@/utils/formatTime';

interface EpisodeSidebarProps {
  videos: PlaylistVideo[];
  currentIndex: number;
  watchedEpisodes: Set<number>;
  onSelectEpisode: (index: number) => void;
  theme: 'purple' | 'blue' | 'dark' | 'white';
  totalDuration: number;
}

export const EpisodeSidebar: React.FC<EpisodeSidebarProps> = ({
  videos,
  currentIndex,
  watchedEpisodes,
  onSelectEpisode,
  theme,
  totalDuration
}) => {
  useLanguage();
  return (
    <aside className="hidden lg:block w-80 border-l bg-card h-screen overflow-y-auto">
      <div className="p-4 border-b sticky top-0 bg-card z-10">
        <h3 className="font-semibold text-base">{translateInterfaceText("Episódios")}</h3>
        <p className="text-sm text-muted-foreground mt-1">
          {videos.length} {" "}{translateInterfaceText("episódios •")}{" "}{formatTime(totalDuration)}
        </p>
      </div>
      
      <div className="p-4">
        <EpisodeList 
          videos={videos}
          currentIndex={currentIndex}
          watchedEpisodes={watchedEpisodes}
          onSelectEpisode={onSelectEpisode}
          theme={theme}
        />
      </div>
    </aside>
  );
};
